import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Reuniao } from 'src/app/core/reuniao';
import { Rotas } from 'src/app/core/rotas';
import { BaseService } from '../base/base.service';

const rootPath = 'api/reuniao/';

@Injectable({
  providedIn: 'root'
})
export class ReuniaoService extends BaseService<Reuniao> {
    

  constructor(http: HttpClient) {
    super(http, Rotas.REUNIOES);
  }

  getAllIntituicaoLogada(area: string) {
    const params: any = {};
    if (area) {
      params.area = area;
    }
    return this.http.get(Rotas.REUNIOES + "instituicao/logada", {params});

  }

  getAllParticipantesReunioes() {
    return this.http.get(`${Rotas.REUNIOES}participantes/combo`);
  }

  getAllRelatoresByCombo() {
    return this.http.get(Rotas.REUNIOES + 'relatores/combo');
  }

  getAllResponsaveisAcoesReuniaoByCombo() {
    return this.http.get(Rotas.REUNIOES + 'acoes/responsaveis/combo');
  }

  getRelator(id: number) {
    return this.http.get(Rotas.REUNIOES + 'relatores/' + id);
  }

  getFilter(
    nomeParticipanteSelecionado: string | number,
    nomeRelatorSelecionado: string | number,
    dataInicio: number,
    dataFim: number,
    localSelecionado: string,
    temaSelecionado: string,
    area: string
  ) {
      const params: any = {};
      if (nomeParticipanteSelecionado) {
        params.nomeParticipante = nomeParticipanteSelecionado;
      }
      if (nomeRelatorSelecionado) {
        params.nomeRelator = nomeRelatorSelecionado;
      }
      if (dataInicio) {
        params.dataInicio = dataInicio;
      }
      if (dataFim) {
        params.dataFim = dataFim;
      }
      if (localSelecionado) {
        params.local = localSelecionado;
      }
      if (temaSelecionado) {
        params.tema = temaSelecionado;
      }
      if (area) {
        params.area = area;
      }

      return this.http.get(Rotas.REUNIOES + "filter", {params});
  }

  alterar(reuniao: Reuniao){
    return this.http.put(Rotas.REUNIOES + reuniao.id, reuniao);
  }
}
